<template>
  <div>
    <div
      v-if="
        $route.path.indexOf('_edit') === -1 &&
        $route.path.indexOf('_detail') === -1
      "
    >
      <el-row :gutter="20">
        <el-col :span="3">
          <el-input
            placeholder="商家编号"
            v-model="params.merchant_id"
            style="width: 100%"
            size="mini"
          ></el-input>
        </el-col>
        <el-col :span="3">
          <el-select
            v-model="params.merchant_type"
            placeholder="入驻商户类型"
            size="mini"
          >
            <el-option label="个人" value="0"></el-option>
            <el-option label="企业" value="1"></el-option>
          </el-select>
        </el-col>
        <el-col :span="3">
          <el-select
            v-model="params.disabled"
            placeholder="是否禁用"
            size="mini"
          >
            <el-option label="否" value="0"></el-option>
            <el-option label="是" value="1"></el-option>
          </el-select>
        </el-col>
        <el-col :span="3">
          <el-select v-model="params.type" placeholder="商家类型" size="mini">
            <el-option label="直营" value="0"></el-option>
            <el-option label="加盟" value="1"></el-option>
          </el-select>
        </el-col>
        <el-col :span="3">
          <el-input
            placeholder="品牌名称"
            v-model="params.name"
            style="width: 100%"
            size="mini"
          ></el-input>
        </el-col>
        <el-col :span="4">
          <!-- <el-input placeholder="经营品类ID" v-model="params.operating_type_id" style="width: 100%" size="mini"></el-input> -->
          <el-cascader
            clearable
            :options="mainCategory"
            v-model="params.operating_type_id"
            @change="handleCategoryChange"
            size="mini"
            style="width: 260px"
          >
          </el-cascader>
        </el-col>

      </el-row>
      <el-row :gutter="20">
        <el-col :span="3">
          <el-input
            placeholder="个人/企业法人姓名"
            v-model="params.operate_name"
            style="width: 100%"
            size="mini"
          ></el-input>
        </el-col>
        <el-col :span="3">
          <el-input
            placeholder="个人/企业法人手机号码"
            v-model="params.operate_mobile"
            style="width: 100%"
            size="mini"
          ></el-input>
        </el-col>

        <el-col :span="3">
          <el-input
            placeholder="运营联系人"
            v-model="params.contact_name"
            style="width: 100%"
            size="mini"
          ></el-input>
        </el-col>
        <el-col :span="3">
          <el-input
            placeholder="运营联系人电话"
            v-model="params.contact_mobile"
            style="width: 100%"
            size="mini"
          ></el-input>
        </el-col>
        <el-col :span="6">
          <el-button type="primary" @click="searchData" size="mini"
            >搜索</el-button
          >
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <el-button type="primary" @click="toAdd()" size="mini"
            >新增商家</el-button
          >
        </el-col>
      </el-row>
      <el-row>
        <div style="color: red;">
          1.企业签约操作:  1.设置企业信息2.上传影印件 3.绑定手机 4.电子会员签约(手机号可不填法人的手机号,可填成其他人的)
          <br>
          2.个人用户签约操作:1.绑定手机  2.实名认证 3.绑定银行卡 4.电子会员签约(银行卡户名必须和实名认证姓名一致,银行卡对应的手机号也必须与实名认证的人员信息一致)
        </div>
      </el-row>
      <el-table :data="dataList" :height="wheight - 130" v-loading="loading">
        <el-table-column
          prop="merchant_id"
          label="商家编号"
        ></el-table-column>
            <el-table-column  label="商家类型">
            <template slot-scope="scope">
            <el-tag
              size="mini"
              effect="plain"
              type="success"
              v-if="scope.row.merchant_type == '0'"
              >个人</el-tag
            >
            <el-tag size="mini" effect="plain" v-else>企业</el-tag>
          </template>
          </el-table-column>
          <el-table-column label="加盟方式">
             <template slot-scope="scope">
             <el-tag
              size="mini"
              effect="plain"
              type="success"
              v-if="scope.row.type == '0'"
              >直营</el-tag
            >
            <el-tag
              size="mini"
              effect="plain"
              type="info"
              v-else-if="scope.row.type == '1'"
              >加盟</el-tag
            >
            </template>
          </el-table-column>
          <el-table-column  label="品牌名称">
             <template slot-scope="scope">
           <div> <small>{{scope.row.name}}</small></div>
          </template>
          </el-table-column>
        <el-table-column
          prop="operate_name"
          label="法人姓名"
        ></el-table-column>
        <el-table-column
          prop="operate_mobile"
          label="法人手机号"
        ></el-table-column>
        <el-table-column prop="contact_name" label="运营联系人"></el-table-column>
        <el-table-column
          prop="contact_mobile"
          label="运营电话"
        ></el-table-column>
        <el-table-column  label="签约">
            <template slot-scope="scope">
            <el-tag
              v-if="scope.row.acct_protocol_no <1 "
                size="mini"
                effect="plain"
              >未签约
              </el-tag>
              <el-tag   size="mini"  type="success" effect="plain" v-else  > 已签约 </el-tag >
          </template>
        </el-table-column>
        <el-table-column  label="状态" >
        <template slot-scope="scope">
              <el-tag size="mini" effect="plain" type="success" v-if="scope.row.disabled=='0'">已启用</el-tag>
              <el-tag size="mini" effect="plain" v-else>已禁用</el-tag>
          </template>
      </el-table-column>
        <!-- <el-table-column label="提现协议编号" >
           <template slot-scope="scope">
              <small> {{scope.row.acct_protocol_no}}</small>
          </template>
        </el-table-column> -->
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button type="text" @click="toUrl(scope.row.merchant_id)" v-if="scope.row.acct_protocol_no" >查看协议</el-button>
<el-button type="text" size="mini" style="color:red" @click="toSign(scope.row)" >签约</el-button>
              <el-popover
  placement="right"
  width="400"
  trigger="click">
   总额:{{(queryArr.allAmount/100).toFixed(2)}}  冻结额: {{(queryArr.freezenAmount/100).toFixed(2)}}
  <el-button slot="reference"  type="text" size="mini" @click="getQueryBalance(scope.row)">余额查询</el-button>
</el-popover>
            <el-button
              size="mini"
             type="text"
              @click="edit(scope.row.merchant_id)"
              >编辑</el-button>
            <el-button
              size="mini"
             type="text"
              @click="del(scope.row.merchant_id,scope.$index)"
              >删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="content-center content-top-padded">
        <el-pagination
          background
          layout="total, sizes, prev, pager, next"
          @current-change="handleCurrentChange"
          @size-change="handleSizeChange"
          :current-page.sync="params.page"
          :page-sizes="[10,20, 50,100]"
          :total="total_count"
          :page-size="params.pageSize"
        >
        </el-pagination>
      </div>
       <el-dialog title="上传影印件" :visible.sync="dialogFormVisible2">
         <el-button type="primary" @click="onSubmitCard(1)">上传营业执照</el-button>
         <el-button type="primary" @click="onSubmitCard(8)">上传身份证正面</el-button>
         <el-button type="primary" @click="onSubmitCard(9)">上传身份证反面</el-button>
        <div slot="footer" class="dialog-footer">
          <el-button @click="dialogFormVisible2 = false">关闭</el-button>

        </div>
      </el-dialog>
        <el-dialog :title="title" :visible.sync="dialogFormVisible">
        <el-form ref="form" :model="form" >
           <el-input
            placeholder="手机号码"
            v-model="form.mobile"
            style="width:300px"
            size="mini"
          ></el-input>
           <el-input
            placeholder="验证码"
            v-model="form.verificationCode"
            style="width:300px"
            size="mini"
          ></el-input>
          <el-button size="mini" @click="sendcode()">{{verify_text}}</el-button>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="dialogFormVisible = false">取 消</el-button>
          <el-button type="primary" @click="onSubmit()">确 定</el-button>
        </div>
      </el-dialog>
          <el-dialog title="绑定银行卡" :visible.sync="dialogFormVisible3">
        <el-form ref="form3" :model="form3" >
         <el-button size="mini" type="primary" @click="toApplyBindBankCard()">绑定银行卡</el-button>
         <br>
         <br>
          <!-- <el-input
            placeholder="流水号"
            v-model="form3.tranceNum"
            style="width:150px"
            size="mini"
          ></el-input>
           <el-input
            placeholder="预留手机"
            v-model="form3.mobile"
            style="width:150px"
            size="mini"
          ></el-input>
           <el-input
            placeholder="验证码"
            v-model="form3.verificationCode"
            style="width:150px"
            size="mini"
          ></el-input> -->
          <!-- <el-button size="mini" @click="sendcode()">{{verify_text}}</el-button> -->
        </el-form>
        <div slot="footer" class="dialog-footer">
       <!--   <el-button @click="dialogFormVisible3= false">取 消</el-button>
          <el-button type="primary" @click="onSubmit3()">确 定</el-button> -->
        </div>
      </el-dialog>

      <el-dialog
        title="签约"
        :visible.sync="Signdialog"
        width="30%"
        :before-close="handleClose">
          <div  v-if="row.merchant_type == 1">

                           <el-tag
                              size="mini"
                              effect="plain"
                              @click="setCompany(row)"
                            v-if="row.is_setcompany <1"
                            >
                              待设置
                            </el-tag>
                            <el-tag  size="mini" effect="plain" v-else> 已设置</el-tag>
                            <el-tag
                              size="mini"
                              effect="plain"
                              @click="upIdcard(row)"
                            >
                              上传影印件
                            </el-tag>
                            <el-tag
                            v-if="row.bind_phone <1"
                            size="mini"
                              effect="plain"
                              @click="bind(row)"
                            >绑定手机
                            </el-tag>
                            <el-tag
                              size="mini"
                              effect="plain"
                              type="success"
                              @click="unbind(row)"
                            v-else
                            >
                              解绑手机
                            </el-tag>
                              <el-tag
                            v-if="row.acct_protocol_no <1 "
                              size="mini"
                              effect="plain"
                              @click="sign(row.merchant_id)"
                            >点击签约
                            </el-tag>
                            <el-tag   size="mini"  effect="plain" v-else  > 已签约 </el-tag >
                    </div>
                     <div v-else>
          <!-- 1. 创建会员
                        2.发送短信验证码, 绑定手机
                        3.实名认证
                         4.请求绑定银行卡
                        5.确认绑定银行卡
                        6.会员电子协议签约-->
                       <el-tag
                            v-if="row.bind_phone <1"
                            size="mini"
                              effect="plain"
                              @click="bind(row)"
                            >绑定手机
                            </el-tag>
                            <el-tag
                              size="mini"
                              effect="plain"
                              type="success"
                              @click="unbind(row)"
                            v-else
                            >
                              解绑手机
                            </el-tag>

                             <el-tag
                                  v-if="row.is_realname <1"
                              size="mini"
                              effect="plain"
                              type="info"
                              @click="toSetRealName(row)"
                            >
                              实名认证
                            </el-tag>
                              <el-tag
                                  v-else
                              size="mini"
                              effect="plain"
                              type="success"
                            >
                              已实名
                            </el-tag>
                            <!-- 绑定银行卡 -->
                             <el-tag
                            v-if="row.is_bindcard <1"
                            size="mini"
                              effect="plain"
                              @click="bindBankCard(row)"
                            >绑定银行卡
                            </el-tag>
                            <el-tag
                              size="mini"
                              effect="plain"
                              type="success"
                              @click="toUnbindBankCard(row)"
                            v-else
                            >
                              解绑银行卡
                            </el-tag>
                            <el-tag
                            v-if="row.acct_protocol_no <1 "
                              size="mini"
                              effect="plain"
                              @click="sign(row.merchant_id)"
                            >点击签约
                            </el-tag>
                            <el-tag   size="mini"  effect="plain" v-else  > 已签约 </el-tag >
                     </div>

      </el-dialog>
    </div>
    <router-view></router-view>
  </div>
</template><script>
import { mapGetters } from "vuex";
import {
  getMerchants,
  addMerchants,
  editMerchants,
  delMerchants,
  getMerchantCategory,
  bindPhone,
  unbindPhone,
  sendcode,
  signContract,
  idcardCollect,
  setCompanyInfo,
  register,
  setRealName,
  applyBindBankCard,
  bindBankCard,
  unBindBankCard,
  queryBalance,
  signContractQuery,
  editMerchantsInfo
  
} from "../../../api/merchant";
export default {
  components: {},
  data() {
    return {
      Signdialog:false,
      total_count: 0,
      mainCategory: [],
      mainCateLoader: false,
      verify_text:'发送验证码',
      text: '发送验证码',
      disabled_button:false,
      title:'绑定手机',
      dialogFormVisible3:false,
      dialogFormVisible2:false,
      dialogFormVisible:false,
      verificationCodeType:9,
      form:{merchant_id:'',mobile:'',verificationCode:''},
      params: {
        page: 1,
        pagesize: 10,
        operating_type_id: "",
      },
      form:{},
      form3:{},
      row:{},
      dataList: [],
      loading: false,
      queryArr:[],
    };
  },
  computed: {
    ...mapGetters(["wheight"]),
  },
  methods: {
    toUrl(merchant_id){
      signContractQuery({merchant_id:merchant_id}).then((res)=>{
        this.$message({
           message: "请稍后...",
           type: "success",
           duration: 2000,
        });
         if(res.data.data.data.url){
            window.open(res.data.data.data.url)
         }
      })
    },
    setRegister(row){
      register({merchant_id:row.merchant_id}).then((res)=>{
            this.$message({
               message: res.data.data.msg,
               type: "success",
               duration: 2000,
            });
       })
    },
    toSign(row){
      this.row=row;
      this.Signdialog=true;
    },
    handleClose(done) {
        this.$confirm('确认关闭？')
          .then(_ => {
            done();
          })
          .catch(_ => {});
      },
    //余额查询
    getQueryBalance(row){
       this.queryArr=[];
        queryBalance({merchant_id:row.merchant_id}).then((res)=>{
            if(res.data.data.status == true){
               this.queryArr=res.data.data.data
            }
       })
    },
    bindBankCard(row){
      this.dialogFormVisible3=true
      this.row=row
    },
    toApplyBindBankCard(){
        //申请绑定银行卡
        applyBindBankCard({merchant_id:this.row.merchant_id}).then((res)=>{
              this.$message({
                message: res.data.data.msg,
                type: "success",
                duration: 2000,
             });
             if(res.data.data.code == 10000){
                this.form3.tranceNum=res.data.data.data.tranceNum
             }

        })
    },
    toSetRealName(row){
      //实名认证
      this.$confirm('是否确认实名认证?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
           setRealName({merchant_id:row.merchant_id}).then((res)=>{
               this.$message({
                  message: res.data.data.msg,
                  type: "success",
                  duration: 2000,
            });
            if(res.data.data.code == 10000){
                this.params.page=1;
                  this.getDataList();
            }
          })
        }).catch(() => {

       });
    },
    setCompany(row){
        this.$confirm('是否确认设置企业信息?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          setCompanyInfo({merchant_id:row.merchant_id}).then((res)=>{
               this.$message({
                  message: res.data.data.msg,
                  type: "success",
                  duration: 2000,
            });
            this.$forceUpdate();
          })
        }).catch(() => {

        });
    },
    upIdcard(row){
       this.dialogFormVisible2=true;
       this.row=row;
    },
    onSubmitCard(val){
      var url ='';
      if(val == 1){
        url = this.row.business_license
      }
      if(val == 8){
        url = this.row.identity_front
      }
      if(val == 9){
        url = this.row.identity_backend
      }
      idcardCollect({merchant_id:this.row.merchant_id,picType:val,url:url}).then((res)=>{
            this.$forceUpdate();
            this.$message({
                  message: res.data.data.msg,
                  type: "success",
                  duration: 2000,
            });
        })
    },
    sign(merchant_id){

       this.$confirm('是否确认签约?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          signContract({merchant_id:merchant_id}).then((res)=>{
              var url =res.data.data.data.url;
              window.open(url)
          })
        }).catch(() => {

        });

    },
    bind(row){
        this.dialogFormVisible=true;
        this.title='绑定手机';
        this.row=row
        this.form.mobile=row.operate_mobile
        this.form.merchant_id=row.merchant_id
        this.verificationCodeType=9;

    },
    unbind(row){
      this.dialogFormVisible=true;
      this.title='解绑手机'
      this.row=row
      this.form.mobile=row.operate_mobile
      this.form.merchant_id=row.merchant_id
      this.verificationCodeType=6;
    },
    //发送短信
    sendcode(){
         sendcode({merchant_id:this.form.merchant_id,verificationCodeType:this.verificationCodeType}).then((res)=>{
            this.$message({
                  message: res.data.data.msg,
                  type: "success",
                  duration: 2000,
             });
             var time=60;
            this.verify_text=time;
            var timer=setInterval(()=>{
              time--;
              this.verify_text=time;
              this.disabled_button=true
              if(time <=0){
                this.verify_text=this.text;
                this.disabled_button=false
                clearInterval(timer);
              }
            },1000);
         })
    },
    onSubmit3(){
        this.form3.merchant_id=this.row.merchant_id
          bindBankCard(this.form3).then((res)=>{
            this.$message({
                  message: res.data.data.msg,
                  type: "success",
                  duration: 2000,
            });
            if(res.data.data.code == 10000){
                this.dialogFormVisible3=false;
                this.params.page=1;
                this.getDataList();
            }

        })
    },
    toUnbindBankCard(row){
        this.$confirm("您确定要解除绑定银行卡？", "提示", {
        cancelButtonText: "取消",
        confirmButtonText: "确定",
        type: "warning",
        beforeClose: (action, instance, done) => {
          if (action === "confirm") {
              unBindBankCard({merchant_id:row.merchant_id}).then((res)=>{
                this.$message({
                      message: res.data.data.msg,
                      type: "success",
                      duration: 2000,
                });
                if(res.data.data.status){
                  this.params.page=1;
                  this.getDataList();
                }
            })
          }
          done();
        },
      });

    },
    //绑定手机
    onSubmit(){
         if(this.row.bind_phone){
          unbindPhone(this.form).then((res)=>{
              this.$message({
                    message: res.data.data.msg,
                    type: "success",
                    duration: 2000,
              });
              if(res.data.data.status == true){
                setTimeout(() => {
                    this.dialogFormVisible=false;
                    this.params.page=1;
                  this.getDataList();
                }, 2000);

              }
          })
         }else{
          bindPhone(this.form).then((res)=>{
              this.$message({
                    message: res.data.data.msg,
                    type: "success",
                    duration: 2000,
              });
              if(res.data.data.status == true){
                setTimeout(() => {
                    this.dialogFormVisible=false;
                      this.params.page=1;
                  this.getDataList();
                }, 2000);
              }
          })
         }

    },
    fetchMainCate() {
      getMerchantCategory({ ishtml: 1 }).then((res) => {
        this.mainCategory = res.data.data;
        this.mainCateLoader = false;
      });
    },
    handleCategoryChange(val) {
      if (val) {
        this.params.operating_type_id = val[1];
      }
    },
    toAdd() {
      this.$router.push({ path: this.matchHidePage("edit") });
    },
    edit(id) {
      this.$router.push({
        path: this.matchHidePage("edit"),
        query: { id: id },
      });
    },
    del(id, index) {
      var that = this;
      this.$confirm("确定要删除该商品？", "提示", {
        cancelButtonText: "取消",
        confirmButtonText: "确定",
        type: "warning",
        beforeClose: (action, instance, done) => {
          if (action === "confirm") {
            delMerchants(id).then((res) => {
              if (res.status) {
                this.$message({
                  message: "已删除",
                  type: "success",
                  duration: 2000,
                });
                setTimeout(function () {
                  that.dataList.splice(index, 1);
                }, 1000);
              }
            });
          }
          done();
        },
      });
    },
    getDataList() {
      this.loading = true;
      getMerchants(this.params)
        .then((response) => {
          this.dataList = response.data.data.list;
          this.total_count = response.data.data.total_count;
          this.loading = false;
        })
        .catch((error) => {
          this.loading = false;
          this.$message({
            type: "error",
            message: "获取列表信息出错",
          });
        });
    },
    handleCurrentChange(page_num) {
      this.params.page = page_num;
      this.getDataList();
    },
    searchData() {
      this.params.page = 1;
      this.getDataList();
    },
    handleSizeChange(pageSize) {
      this.params.page = 1;
      this.params.pagesize = pageSize;
      this.getDataList();
    },
    //导出预留
    exportData() {
      this.$message({
        type: "success",
        message: "待开发!",
      });
    },
    goBack () {
        console.log("点击了浏览器的返回按钮",document.URL);
        // history.pushState(null, null, document.URL);
        this.params.page = 1;
        this.getDataList();
    },
  },
  destroyed () {
    window.removeEventListener('popstate', this.goBack, false);
},
  mounted() {
    if (window.history && window.history.pushState) {
        // 向历史记录中插入了当前页
        history.pushState(null, null, document.URL);
        window.addEventListener('popstate', this.goBack, false);
    }

    this.getDataList();
    this.fetchMainCate();
  },
};
</script>
<style scoped lang="scss">
.el-row {
  margin-bottom: 20px;
  &:last-child {
    margin-bottom: 0;
  }
  img {
    width: 90%;
  }
}
.el-col {
  border-radius: 4px;
}
.bg-purple-dark {
  background: #99a9bf;
}
.bg-purple {
  background: #d3dce6;
}
.bg-purple-light {
  background: #e5e9f2;
}
.grid-content {
  border-radius: 4px;
  min-height: 10px;
  img {
    width: 90%;
  }
}
.row-bg {
  padding: 10px 20px;
  background-color: #f9fafc;
}
.service-label .el-checkbox:first-child {
  margin-left: 15px;
}
.service-label .el-input:first-child {
  margin-left: 15px;
}
.grid-detail {
  max-height: 300px;
  overflow-y: scroll;
  margin-bottom: 20px;
}
.el-carousel {
  width: 375px;
}
.grid-detail {
  table,
  .detail-content-wrap,
  .detail-content-item {
    width: 100% !important;
  }
  img {
    width: 100%;
  }
}
.grid-attribute {
  table {
    width: 100% !important;
  }
}
</style>



// WEBPACK FOOTER //
// list.vue?7969d443